var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"risk",attrs:{"role":"img","aria-label":_setup.ariaLabel}},[_vm._l((5),function(i){return _c('span',{key:i,staticClass:"dot",style:({
            '--progress': _setup.getDotProgress(_vm.riskScore, i) + '%',
            '--color': _setup.getDotColor(i)
        }),attrs:{"aria-hidden":"true"}})}),_c('span',{staticClass:"risk-text",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.riskScore)+"/5")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }